export default function parseQueryParams(search: string): { [key: string]: string } {
  if (!search || search === '') return {};
  const params: { [key: string]: string } = {};
  search.replace(/^\?/, '').split('&').forEach(hash => {
    const [key, value] = hash.split('=');
    params[decodeURIComponent(key)] = decodeURIComponent(value);
  });
  return params;
}
